<template>
	<div class="brick">
		<div class="list_top_box">
			<span class="int_type_no_border mgr_15">
				<em class="lt_text">P/O Date</em>
				<span class="mgr_10"> <CustomDatePicker v-model="from_date" /> ~ <CustomDatePicker v-model="to_date" /> </span>
			</span>

			<span class="int_type_no_border mgr_15">
				<em class="lt_text">Vendor Code</em>
				<PartnerSelect v-model="vendor_code" ph="Vendor Code" :showName="false" :vendorOnly="true" />
			</span>

			<span class="int_type_no_border mgr_15">
				<a href="javascript: void(0);" class="search_bt" @click="search">Search</a>
				<a href="javascript: void(0);" class="gray_bt" @click="reset">Reset</a>
			</span>

			<span v-if="company_id" class="int_type_no_border">
				<a href="javascript: void(0);" class="gray_bt" @click="print">Print</a>
				<a href="javascript: void(0);" class="gray_bt" @click="excelExport">Excel</a>
			</span>

			<span class="fl_r">
				<em class="lt_text"><b class="mgr_15">Currency: $</b></em>
			</span>
		</div>
		<table v-if="company_id" class="list_tbl" id="purchaseByVendor">
			<colgroup>
				<col style="width: 19%;" />
				<col style="width: 9%;" />
				<col style="width: 9%;" />
				<col style="width: 9%;" />
				<col style="width: 9%;" />
				<col style="width: 9%;" />
				<col style="width: 9%;" />
				<col style="width: 9%;" />
				<col style="width: 9%;" />
				<col style="width: 9%;" />
			</colgroup>
			<thead>
				<tr>
					<th>Vendor Name</th>
					<th>Vendor Code</th>
					<th>Total Order Amt</th>
					<th>Total Order Qty</th>
					<th>Total Shipment Amt</th>
					<th>Total Shipment Qty</th>
					<th>Total Received Amt</th>
					<th>Total Received Qty</th>
					<th>Total Invoice Amt</th>
					<th>Total Invoice Qty</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td class="truncate">{{ vendor.vendor_name }}</td>
					<td class="truncate">{{ vendor.vendor_code }}</td>
					<td class="al_right">{{ total.total_order_amt | toCurrency }}</td>
					<td class="al_right">{{ total.total_order_qty | commaSeparated }}</td>
					<td class="al_right">{{ total.total_ship_amt | toCurrency }}</td>
					<td class="al_right">{{ total.total_ship_qty | commaSeparated }}</td>
					<td class="al_right">{{ total.total_rcvd_amt | toCurrency }}</td>
					<td class="al_right">{{ total.total_rcvd_qty | commaSeparated }}</td>
					<td class="al_right">{{ total.total_inv_amt | toCurrency }}</td>
					<td class="al_right">{{ total.total_inv_qty | commaSeparated }}</td>
				</tr>
			</tbody>
			<thead>
				<tr>
					<th>Item Name</th>
					<th>Item Id</th>
					<th>Order Amt</th>
					<th>Order Qty</th>
					<th>Shipment Amt</th>
					<th>Shipment Qty</th>
					<th>Received Amt</th>
					<th>Received Qty</th>
					<th>Invoice Amt</th>
					<th>Invoice Qty</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in list_by_item" :key="index">
					<td class="truncate">{{ item.item_name }}</td>
					<td class="truncate">{{ item.item_id }}</td>
					<td class="al_right">{{ item.order_amt | toCurrency }}</td>
					<td class="al_right">{{ item.order_qty | commaSeparated }}</td>
					<td class="al_right">{{ item.ship_amt | toCurrency }}</td>
					<td class="al_right">{{ item.ship_qty | commaSeparated }}</td>
					<td class="al_right">{{ item.rcvd_amt | toCurrency }}</td>
					<td class="al_right">{{ item.rcvd_qty | commaSeparated }}</td>
					<td class="al_right">{{ item.inv_amt | toCurrency }}</td>
					<td class="al_right">{{ item.inv_qty | commaSeparated }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import { today, monthAdd } from '@/utils/date';
import { apiPurchaseByVendor } from '@/api/report/report';
import { apiGetReportTemplate, reportMrtUrl, Report, PrintType, exportExcel } from '@/api/util';
export default {
	data: () => ({
		vendor_code: null,
		from_date: null,
		to_date: null,

		list_by_item: [],
		vendor: {},
		total: {},
		company_id: null,
		period: {},
	}),
	components: {
		CustomDatePicker,
		PartnerSelect,
	},
	methods: {
		async print() {
			if (!this.company_id) return this.$toast.error('No List To Export');

			const reportTemplate = await apiGetReportTemplate('PurchaseByVendor', reportMrtUrl('PurchaseByVendor'));
			const data = { period: this.period, vendor: this.vendor, total: this.total, list_by_item: this.list_by_item };
			const report = new Report(reportTemplate, data, 'PurchaseByVendor', PrintType.Normal, false, false, null, 70);
			this.$store.commit('setReport', report);
		},
		excelExport() {
			if (!this.company_id) return this.$toast.error('No List To Export');
			exportExcel('purchaseByVendor', 'purchaseByVendor');
		},
		reset() {
			this.vendor_code = null;
			this.from_date = monthAdd(-6);
			this.to_date = today();
		},
		async search() {
			if (!this.vendor_code) return this.$toast.error('Please, Select Vendor');
			if (!(this.from_date && this.to_date)) return this.$toast.error('Please, Select Period');

			let { data } = await apiPurchaseByVendor(this.vendor_code, this.from_date, this.to_date);

			if (data.list_by_item) this.list_by_item = data.list_by_item;
			else this.list_by_item = [];

			if (data.total) this.total = data.total;
			else this.total = {};

			if (data.vendor) this.vendor = data.vendor;
			else this.vendor = {};

			if (data.company_id) this.company_id = data.company_id;
			else this.company_id = null;

			this.period = { from_date: this.from_date, to_date: this.to_date };
		},
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_purchaseByVendor');
		this.$store.commit('setSubTitle', 'Report -> Purchase by Vendor');

		this.reset();
	},
};
</script>

<style></style>
